<template>
    <div id="charLib">
        <div class="main-panel">
            <div>
                <div class="main-panel__header">
                    <el-date-picker
                        size="medium"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        style="width: 225px;"
                        :clearable="false"
                        v-model="dateRange"
                        @change="getList"
                    ></el-date-picker>
                    <el-select size="medium" @change="queryOpnTypeEnum()" v-model="dataSubjectType" placeholder="请选择" style="width:130px">
                        <el-option label="全部操作对象" :value="0"></el-option>
                         <el-option v-for="item in dataSubjectTypeList" :key="item.key" :label="item.value" :value="item.key">  </el-option>
                        <!-- <el-option value="USER" label="用户"></el-option>
                        <el-option value="DEPART" label="部门"></el-option>
                        <el-option value="DEPART_ADMIN" label="部门主任"></el-option>
                        <el-option value="GROUP" label="群组"></el-option>
                        <el-option value="FACE" label="人脸"></el-option>
                        <el-option value="CLASSES" label="所教课程"></el-option> -->
                    </el-select>      
                     <el-select size="medium" @change="getList()" v-model="opnType" placeholder="请选择" style="width:130px">
                        <el-option label="全部操作类型" :value="0"></el-option>
                          <el-option v-for="item in opnTypeList" :key="item.key" :label="item.value" :value="item.key">  </el-option>
                        <!-- <el-option value="add" label="新增"></el-option>
                        <el-option value="update" label="编辑"></el-option>
                        <el-option value="delete" label="删除"></el-option> -->
                    </el-select>                 
                     <el-select size="medium" @change="getList()" v-model="pushStatus" placeholder="请选择" style="width:130px">
                        <el-option label="全部下发状态" :value="-1"></el-option>
                        <el-option :value="0" label="下发中"></el-option>
                        <el-option :value="1" label="成功"></el-option>
                        <el-option :value="2" label="失败"></el-option>
                    </el-select>   
                     <el-input style="width: 20%"
                              size="medium"
                              placeholder="请输入相关数据（操作员或操作数据）" icon="el-icon-search" @keyup.enter.native="handleInputChange"
                              v-model.trim="dataName">
                    </el-input>
                    <el-input style="width: 20%" class="search-input search-input--right"
                              size="medium"
                              placeholder="请输入学校id或名称"
                               icon="el-icon-search" @keyup.enter.native="handleInputChange"
                              v-model.trim="schoolInfo">
                        <el-button slot="append" size="medium" icon="el-icon-search"
                                   @click="getList"></el-button>
                    </el-input>
                </div>

            </div>
            <div>

                <el-table
                    :height="windowHeight - 210"
                    :data="dataList"
                    style="width: 100%" border
                >
                    <el-table-column
                        label="操作员"
                        prop="opnUserName"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作时间"
                        align="center" show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{scope.row.operatedTime?scope.row.operatedTime.substring(0, 19):""}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作学校" show-overflow-tooltip
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{scope.row.schoolName}}({{scope.row.schoolId}})
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作对象"
                        align="center" show-overflow-tooltip
                        prop="type"
                    >
                        <template slot-scope="scope">
                            {{scope.row.dataSubjectType}}
                            <!-- <sapn v-if="scope.row.dataSubjectType=='DEPART'">部门</sapn>
                            <sapn v-if="scope.row.dataSubjectType=='USER'">用户</sapn>
                            <sapn v-if="scope.row.dataSubjectType=='DEPART_ADMIN'">部门主任</sapn>
                            <sapn v-if="scope.row.dataSubjectType=='FACE'">人脸</sapn>
                            <sapn v-if="scope.row.dataSubjectType=='GROUP'">群组</sapn>
                            <sapn v-if="scope.row.dataSubjectType=='CLASSES'">所教课程</sapn> -->
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作类型"
                        align="center" show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                             <el-tooltip class="item" effect="dark" :content="scope.row.opnSource" placement="top">
                                 <sapn> {{scope.row.opnType}}</sapn>
                                
                                <!-- <sapn v-if="scope.row.opnType=='add'">新增</sapn>
                                                    <sapn v-if="scope.row.opnType=='update'">编辑</sapn>
                                                    <sapn v-if="scope.row.opnType=='delete'">删除</sapn> -->
                                </el-tooltip>
                         
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作数据" show-overflow-tooltip
                        align="center"
                    >
                        <template slot-scope="scope">
                          {{scope.row.dataName}}({{scope.row.dataType}}--{{scope.row.dataId}})
                        </template>
                    </el-table-column>
                     <el-table-column label="下发状态" align="center">
                            <template slot-scope="scope">   
                                   <el-button type="text" size="small"  @click="pushDataLog(scope.row)">{{scope.row.pushStatus}}</el-button>    
                            </template>
                        </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination
                        @size-change="sizeChangeHandler"
                        @current-change="currentChangeHandler"
                        :current-page.sync="pagination.pageNo"
                        :page-sizes="[10, 20, 30, 50]"
                        :page-size.sync="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="pagination.pages"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';
    import {queryByPage,querySubjectTypeEnum,queryOpnTypeEnum} from '@/api/system';
    export default {
        name: 'queryByPage',
        mixins: [windowResize, baseMixin],
        data() {
            return {
                pushStatus:-1,
                opnType:0,
                dataSubjectType:0,
                dataList: [],
                dateRange: [new Date, new Date],
                schoolInfo: '',
                dataContent: '',
                pagination:{
                    pageNo:1,
                    pageSize:20
                },
                dataName:"",
                dataSubjectTypeList:[],
                opnTypeList:[]
            }
        },
        mounted() {
            this.queryByPage();
            this.querySubjectTypeEnum()
        },
        methods: {
            getList() {
                this.queryByPage();
            },
            querySubjectTypeEnum(){
              querySubjectTypeEnum()
                    .then(data => {                       
                        this.dataSubjectTypeList = data.data.data;
                        this.queryOpnTypeEnum();
                    })
            },
             queryOpnTypeEnum(){
              queryOpnTypeEnum(this.dataSubjectType)
                    .then(data => {                       
                        this.opnTypeList = data.data.data;
                        this.opnType=0;
                        this.getList()
                    })
            },
              pushDataLog(obj){
                  this.$router.push({
                            path: '/main/systemMaintain/pushData/pushDataLog',
                            query: {
                                beginTime: moment(this.dateRange[0]).format('YYYY-MM-DD'),
                                endTime: moment(this.dateRange[1]).format('YYYY-MM-DD'),
                                pushMsgId:obj.pushMsgId
                            }
                        })
                },
            queryByPage() {              
                queryByPage({
                    pushStatus: this.pushStatus,
                    beginTime: moment(this.dateRange[0]).format('YYYY-MM-DD'),
                    endTime: moment(this.dateRange[1]).format('YYYY-MM-DD'),
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize,
                    schoolInfo: this.schoolInfo,
                    dataName:this.dataName,
                    opnType:this.opnType,
                    dataSubjectType:this.dataSubjectType
                })
                    .then(data => {
                        const pageData = data.data.data;
                        this.pagination.total = pageData.pagination.total;
                        this.dataList = pageData.dataList;
                    })
            },
            handleInputChange() {
                this.queryByPage();
            },
            sizeChangeHandler() {
                this.pagination.pageNo = 1;
                this.queryByPage();
            },
            currentChangeHandler() {
                this.queryByPage();
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/mixin";

    #charLib {
        height: 100%;
    }

    .group-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }

    .main-panel {
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .group-item--title {
        width: 100px;
        height: 26px;
        margin-left: 20px;
        margin-top: 10px;
        display: block;
        color: #7B7B7B;
    }

    .group-item {
        height: 30px;
        text-align: left;
        line-height: 30px;
        display: block;
        padding: 0 30px;
        cursor: pointer;
        border-radius: 2px;
        position: relative;

        .fa {
            float: right;
            margin: 7px 0 0 10px;
            display: none;
        }

        &:hover {
            background-color: #ECECEC;

            .fa {
                display: block;
            }
        }

        &.group-item--active {
            background-color: #409EFF;
            color: #fff;

            .fa-edit {
                color: #fff;
            }
        }

        .fa-trash {
            color: #f08080;
        }

        .fa-edit {
            color: #409EFF;
        }
    }

    .char-list {
        padding-top: 12px;
    }

    .word-item {
        float: left;
        box-sizing: border-box;
        height: 80px;
        border: 2px solid #ddd;
        margin: 0 10px 10px 0;
        text-align: center;
        padding: 14px;
        font-size: 36px;
        cursor: pointer;
        position: relative;

        .fa-edit {
            position: absolute;
            font-size: 16px;
            right: 5px;
            top: 5px;
            color: #409EFF;
            display: none;
        }

        &:hover {
            .fa-edit {
                display: block;
            }
        }

        &.word-item--active {
            border: 2px solid #409EFF;
        }
    }

    .main-panel__header {
        padding-bottom: 10px;
        // border-bottom: 1px solid #e4e7ed;
    }

    .char-container {
        width: 70px;
        height: 70px;
        font-size: 52px;
        margin: 0 auto;
        text-align: center;
        line-height: 80px;
        margin-bottom: 5px;
    }

    .form-item-container {
        width: 500px;
        margin: 0 auto;
        text-align: center;
        margin-bottom: 10px;
    }

    .dialog-value {
        display: inline-block;
        vertical-align: middle;
        width: 280px;
        text-align: left;
    }

    .uploader-container {
        width: 140px;
    }

    .dialog-label {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
        text-align: right;
        margin-right: 10px;
    }

    .add-line {
        color: #409EFF;
        cursor: pointer;
    }

    .form-item-container--voice {
        & > * {
            vertical-align: top;
        }

        .fa-close {
            color: #f08080;
            margin-left: 10px;
        }
    }
    .link {
        color: #20a0ff;
        cursor: pointer;
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }

    #charLib .form-item-container--line {
        .upload-file-item {
            width: 80px;
            height: 80px;
        }

        .upload-file-item img {
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/pushData/changeLog.vue